module.exports = __webpack_public_path__ + "static/inspiration-static--ef3ca98aaa876038743d1dd152e589cf.png";